//libraries
import React from 'react';
import styled from 'styled-components';

// custom components
import Layout from 'components/Layout';
import CreateStoryForm from 'modules/RealStories/CreateStory';

// styled components
import { Frame, ColumnedFlex } from 'shared/styledComponents';
import { H1, Title } from 'shared/typography';

// hooks
import useScrollPageToTop from 'hooks/useScrollPageToTop';

const MainSection = styled(ColumnedFlex)<any>`
  width: 100%;
  align-items: center;
  background-color: ${({ theme: { colors } }): string => colors.secondary};
  padding-bottom: 60px;
`;

const MainHeading = styled(H1)`
  padding: 50px 0 30px;
`;

const SubTitle = styled(Title)<any>`
  line-height: 30px;
`;

const CreateStory = (): JSX.Element => {
  useScrollPageToTop();
  return (
    <Layout>
      <MainSection as="section">
        <Frame>
          <MainHeading>Share your journey</MainHeading>
          <SubTitle size="small">
            It’s time for raw, real talk. We believe in being open and honest about topics surrounding the path to
            parenthood. We do this by sharing sharing fertility, pregnancy, postpartum and parenthood journeys on our
            website and social media platforms.
          </SubTitle>
        </Frame>
      </MainSection>
      <Frame>
        <CreateStoryForm />
      </Frame>
    </Layout>
  );
};

export default CreateStory;
